import React from 'react';
import styled from 'styled-components';
import ContactForm from '../components/ContactForm';
import { Container } from '../styles/GlobalStyles';
import { theme } from '../styles/theme';

// Outer container mirrors the shell pattern shared by ProfilePage and
// SettingsPage so /profile, /settings, and /contact feel like rooms in the
// same building. `overflow: clip` (not hidden) so the form's sticky action
// bar can attach to the viewport bottom instead of being trapped here.
const ContactContainer = styled.div`
  min-height: calc(100vh - 72px);
  background: ${theme.colors.backgroundSecondary};
  padding: ${theme.spacing[8]} 0 ${theme.spacing[16]};
  margin: 30px 30px 0;
  border: 1px solid ${theme.colors.border};
  border-radius: 20px;
  position: relative;
  overflow: clip;

  @media (max-width: ${theme.breakpoints.md}) {
    margin: 20px;
  }

  @media (max-width: ${theme.breakpoints.sm}) {
    margin: 0;
    border-radius: 0;
    border: none;
  }
`;

const ContentWrapper = styled.div`
  position: relative;
  z-index: 1;
  padding: 0 ${theme.spacing[4]};
`;

// ContactPage is now a thin shell — the form owns its own hero, info rail,
// and success state. Avoids the previous double-header confusion where the
// page wrapped the form in its own redundant title block.
const ContactPage: React.FC = () => {
  return (
    <ContactContainer>
      <Container>
        <ContentWrapper>
          <ContactForm />
        </ContentWrapper>
      </Container>
    </ContactContainer>
  );
};

export default ContactPage;
